import { Link, NavLink } from "react-router-dom";
import { Logout } from "../../../utils/Logout";
import { useState } from "react";

const OfHeader = ({ bar, me, setSearch, geolocation, setGeolocation, provincias, onClick, getParams, navigate }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  return (
    <div
      className="offcanvas offcanvas-top min-vh-100"
      tabindex="-1"
      id="offcanvasTop-header"
      aria-labelledby="offcanvasTopLabel"
    >
      <div className="offcanvas-header py-3">
        <h5
          className="offcanvas-title Grifter"
          id="offcanvasTopLabel-header"
          style={{ fontSize: "12px" }}
        >
          <img src="/assets/img/marca/antesala-logo.svg" width="60px" alt="" />
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="">
          <ul className="col-md-6 navbar-nav justify-content-start align-items-center  mb-2 mb-lg-0 w-full border-0">
            {bar.map((menu, index) => {
              if (menu.dropdown) {
                const dropdownId = `menu-${index}`;
                const isOpen = openDropdown === dropdownId;
                return (
                  <li
                    key={index}
                    className={`w-100 py-2 nav-item text-start ${menu.show ? "" : "d-none"
                      }`}
                    style={{borderBottom: "0.5px solid rgba(0,0,0,0.2)"}}
                  >
                    <button
                      className="nav-NavLink fs-5 Grifter text-dark fw-bold bg-transparent border-0 w-100 text-start p-0 d-flex justify-content-between align-items-center"
                      onClick={() => toggleDropdown(dropdownId)}
                    >
                      {menu.name}
                      <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
                    </button>
                    <div
                      className="overflow-hidden transition-all"
                      style={{
                        maxHeight: isOpen ? `${menu.dropdown.length * 50}px` : '0px',
                        transition: 'max-height 0.3s ease-in-out'
                      }}
                    >
                      <ul className="list-unstyled ps-3 mt-2">
                        {menu.dropdown.map((submenu, subIndex) => {
                          return (
                            <li key={subIndex} className="mb-2">
                              <Link
                                className="text-dark fw-bold Grifter text-decoration-none d-block"
                                to={submenu.link}
                              >
                                {submenu.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </li>
                );
              } else {
                return (
                  <li
                    key={index}
                    className={`w-100 mx-2 py-2 nav-item text-start ${menu.show ? "" : "d-none"
                      }`}
                    style={{borderBottom: "0.5px solid rgba(0,0,0,0.2)"}}
                  >
                    <Link
                      className="nav-NavLink active fs-5 Grifter text-dark fw-bold"
                      to-current="page"
                      to={menu.link}
                    >
                      {menu.name}
                    </Link>
                  </li>
                );
              }
            })}
          </ul>

          <div className="col-md-6 d-md-flex justify-content-center align-items-center d-block">
            <div className="d-flex mb-2 w-100">
              <input
                className="form-control border border-dark "
                style={{ borderRadius: "10px 0px 0px 10px" }}
                type="search"
                placeholder="Buscar"
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") onClick({ target: { name: "search" } });
                }}
              />
              <label
                className="btn btn-dark border-0 py-1 d-flex justify-content-center align-items-center"
                style={{ borderRadius: "0px 10px 10px 0px" }}
              >
                <i className="bi bi-search"></i>
                <button
                  className="d-none"
                  name="search"
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>

            {me ? (
              <div className="mx-md-2 mb-2">
                <button
                  className="btn btn-outline-dark w-100 d-flex justify-content-between align-items-center"
                  style={{ borderRadius: "20px" }}
                  type="button"
                  onClick={() => toggleDropdown('user')}
                >
                  <span>{`${me.nombre} ${me.apellido}`}</span>
                  <i className={`bi bi-chevron-${openDropdown === 'user' ? 'up' : 'down'}`}></i>
                </button>
                <div
                  className="overflow-hidden"
                  style={{
                    maxHeight: openDropdown === 'user' ? '250px' : '0px',
                    transition: 'max-height 0.3s ease-in-out'
                  }}
                >
                  <ul className="list-unstyled mt-2">
                    <li
                      className={`${me.roles[0].nombre == "adm" ||
                        me.roles[0].nombre == "prd" ||
                        me.roles[0].nombre == "sala"
                        ? ""
                        : "d-none"
                        }`}
                    >
                      <a
                        className="btn btn-outline-dark w-100 border-0 text-start"
                        href={"/dashboard/perfil"}
                      >
                        Administrador
                      </a>
                    </li>
                    <li>
                      <button
                        className="btn btn-outline-dark w-100 border-0 text-start"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasTop-membresia"
                        aria-controls="offcanvasTop-membresia"
                      >
                        Membresias
                      </button>
                    </li>
                    <li>
                      <button
                        className="btn btn-outline-dark w-100 border-0 text-start"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasTop-entradas"
                        aria-controls="offcanvasTop-entradas"
                      >
                        Entradas
                      </button>
                    </li>
                    <li>
                      <button
                        className="btn btn-outline-dark w-100 border-0 text-start"
                        onClick={(e) => Logout()}
                      >
                        Cerrar Sesion
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            ) : (
              <div>
                <label
                  className="btn btn-custom-naranja text-white d-flex py-4 px-1 justify-content-center align-items-center"
                  style={{ borderRadius: "10px", maxHeight: "35px" }}
                >
                  <i className="rounded-pill bi bi-person-circle fs-6 me-1"></i>
                  <span className="d-flex Grifter" style={{ fontSize: "12px" }}>
                    INGRESAR
                  </span>
                  <button
                    className="d-none"
                    name="login"
                    onClick={(e) => onClick(e)}
                  ></button>
                </label>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfHeader;
